import { Collection } from "@/shared/Collection";
import { Classification } from "../entities/Classification";

export class ClassificationCollection extends Collection {
    item(element) {
        return new Classification(element);
    }
}